<template>
  <v-row>
    <v-col class="text-center" lg="4" md="6" cols="12">
      <v-card class="elevation-12">
        <v-card-title>Активный клиент</v-card-title>
        <v-card-text>
          <ActiveClient/>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col lg="4" md="6" cols="12">
      <v-card class="elevation-12 pb-2">
        <v-btn v-if="isAllowMailsListing" block color="success" class="mt-1 rounded-0" :to="{name: 'mails-listing'}">
          Письма
        </v-btn>
       <v-btn v-if="isAllowMailsMonitoringListing" block color="success" class="mt-1 rounded-0"
              :to="{name: 'mails-monitoring'}">Мониторинг писем
       </v-btn>
        <v-btn v-if="isAllowDistributionByPostOfficesListing" block color="success" class="mt-1 rounded-0"
               :to="{name: 'mails-distribution'}">Распределение писем
        </v-btn>
        <v-btn v-if="isAllowPrintPackagesListing" block color="success" class="mt-1 rounded-0"
               :to="{name: 'print-packages'}">Печатные реестры
        </v-btn>
        <v-btn v-if="isAllowPostPackagesListing" block color="success" class="mt-1 rounded-0"
               :to="{name: 'post-packages'}">Пост-пакеты
        </v-btn>
        <v-btn v-if="isAllowPostPackageGroupsListing" block color="success" class="mt-1 rounded-0"
               :to="{name: 'post-package-groups'}">Сводные реестры
        </v-btn>
        <v-btn block color="success" class="mt-1 rounded-0" :to="{name: 'mails-perform'}">Ввод результата</v-btn>
        <v-btn v-if="isAllowStatistics" block color="info" class="mt-1 rounded-0" :to="{name: 'report-processing-region'}">
          Статистика филиалов
        </v-btn>
        <v-btn v-if="isAllowStatistics" block color="info" class="mt-1 rounded-0" :to="{name: 'report-processing-client'}">
          Статистика организаций
        </v-btn>
        <v-btn v-if="isAllowUserStatistics" block color="info" class="mt-1 rounded-0" :to="{name: 'report-users'}">
          Статистика пользователей
        </v-btn>
        <v-btn v-if="AllowDeliveredStatistics" block color="info" class="mt-1 rounded-0" :to="{name: 'report-delivered'}">
          Статистика о доставка
        </v-btn>
        <v-btn v-if="AllowClientIncomingStatistics" block color="info" class="mt-1 rounded-0" :to="{name: 'report-clientincomming'}">
          Статистика всех организаций
        </v-btn>
        <v-btn v-if="AllowPerformStatistics" block color="info" class="mt-1 rounded-0" :to="{name: 'report-perform'}">
          Статистика статусов
        </v-btn>
        <v-btn v-if="AllowTaskPerformanceStatistics" block color="info" class="mt-1 rounded-0" :to="{name: 'report-processing-regional-task-performance'}">
          Статистика по пост пакетам
        </v-btn>
        <v-btn
            v-if="AllowPagesCountStatistics"
            block
            color="info"
            class="mt-1 rounded-0"
            :to="{name: 'report-processing-pages-count-region'}"
        >
          Статистика по бумагам по количеству
        </v-btn>

        <v-btn
            v-if="AllowPagesCountStatistics"
            block
            color="info"
            class="mt-1 rounded-0"
            :to="{name: 'report-processing-pages-sum-region'}"
        >
          Статистика по бумагам по сумму
        </v-btn>

        <v-btn
            v-if="AllowPagesCountStatistics"
            block
            color="info"
            class="mt-1 rounded-0"
            :to="{name: 'report-processing-pages-economist'}"
        >
          Статистика для економиста
        </v-btn>


        <v-btn v-if="isAllowUserManagements" block color="warning" class="mt-1 rounded-0"
               :to="{name: 'users-management'}">Управление пользователями
        </v-btn>
        <v-btn v-if="isAllowPostIndexSettings" block color="warning" class="mt-1 rounded-0"
               :to="{name: 'settings-post-index'}">Настройка пост-отделений
        </v-btn>
        <v-btn v-if="isAllowPostIndexSearch" block color="warning" class="mt-1 rounded-0"
               :to="{name: 'post-index-search'}">Поиск пост-отделений
        </v-btn>

        <v-btn v-if="isAllowBulkUnsetPostPackageMails" block color="error" class="mt-1 rounded-0"
               :to="{name: 'mails-bulk-unset-post-package'}">Массовый досыл писем
        </v-btn>

        <v-btn v-if="isAllowMailsForwarding" block color="error" class="mt-1 rounded-0"
               :to="{name: 'mails-forward'}">Авто досыл
        </v-btn>

        <v-btn block color="secondary" class="mt-10 rounded-0" @click="onLogoutClicked">Выйти</v-btn>
      </v-card>
    </v-col>



    <v-col lg="4" md="6" cols="12" v-if="isCirclePdfAllowed">
      <v-card class="elevation-12 pb-2">
        <v-btn block color="success" class="mt-1 rounded-0" :href="circle1TimeUrl">Скачать кольцовку 1-смены</v-btn>
        <v-btn block color="success" class="mt-1 rounded-0" :href="circle2TimeUrl">Скачать кольцовку 2-смены</v-btn>
      </v-card>
      <v-card class="mx-auto mt-10" max-width="800" style="padding: 10px; position: absolute; bottom: 0px;">
        <span style="font-size: 17px">Получение почты от не происходило в течение указанного часа</span>
        <v-virtual-scroll :items="expiredClients" itemHeight="50" height="200" >
          <template  v-slot:default="{ item }" style="border: 1px solid #111;">
            <v-btn block :color="getColor(item)" class="d-flex justify-space-between mt-1 rounded-0">
              <span style="font-size: 12px">{{ clientMapping(item) }} {{ item.date }}</span>
              <v-btn @click="removeClient(index)" style="background-color: transparent; border: 0px; box-shadow: 0 0 0 0; color: white; font-size: 20px" class="close-btn">x</v-btn>
            </v-btn>
          </template>
        </v-virtual-scroll>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ActiveClient from "../../components/ActiveClient";
import {AUTH_LOGOUT} from "@/store/modules/auth/actions";
import _ from "underscore";
import {
  AllowAccountsManagement,
  AllowClientIncomingStatistics,
  AllowCreatePackageGroup,
  AllowCreatePostPackage,
  AllowCreatePrintPackage,
  AllowDeleteFromPostPackage,
  AllowDeliveredStatistics,
  AllowDistributionByPostOffices, AllowMailForward,
  AllowMailsMonitoring,
  AllowOperatorsStatistics, AllowPagesCountStatistics,
  AllowPagesEconomistStatistics,
  AllowPerformStatistics,
  AllowPostIndexSearch,
  AllowPostIndexSettings,
  AllowStatistics, AllowTaskPerformanceStatistics, AllowTestStatistics
} from "@/enums/permission";
import MailService from '@/services/mail.service'
import index from "vuex";


export default {
  name: "DashboardView",
  components: {
    ActiveClient
  },
  data() {
    return {
      showContent: false,
      circle1TimeUrl: '/smena-1.pdf',
      circle2TimeUrl: '/smena-2.pdf',
      areGaiMailsArrivedWithinPeriod: true,
      expiredClients: [],
      clientsWithException: [],
      clientsNotFound: []
    }
  },
  methods: {
    getColor(item){
      if(this.clientsWithException.includes(item)){
        return "error"
      }
      else if(this.clientsNotFound.includes(item)){
        return "gray"
      }
      return "warning"
    },
    removeClient(index) {
      this.expiredClients.splice(index, 1);
    },
    clientMapping(clientId) {
      const idStr = clientId.toString();
      switch (idStr) {
        case "1":
          return "ГУББД (ГАИ)";
        case "3":
          return "Министерство Юстиции (JVM)";
        case "5":
          return "Фактура.уз (FKT)";
        case "6":
          return "Единая система гибридной почты (EHM)";
        case "7":
          return "Верховный суд РУз (OSM)";
        case "8":
          return "ПромСтройБанк (PSB)";
        case "9":
          return "Прокуратура РУз (ORP)";
        case "10":
          return "Э-Маъмурий иш (EMI)";
        case "11":
          return "Народный банк (XB)";
        case "12":
          return "Банк Ипак Йули (IYB)";
        case "13":
          return "ТБС Банк (TBC)";
        case "15":
          return "Асака Банк (ASK)";
        case "16":
          return "Тенге Банк (TNG)";
        case "17":
          return "Зудмолл (ZDM)";
        case "18":
          return "Венду (VND)";
        case "22":
          return "Ипотека Банк (IPK)";
        case "24":
          return "НБУ Банк (NBU)";
        default:
          return "Unknown Client";
      }
    },
    onLogoutClicked() {
      this.$store.dispatch(AUTH_LOGOUT)
    },
    checkMailArrived() {
      let clients = { 1: 1, 3: 24, 5: 24, 6: 2, 7: 2, 8: 72, 9: 24, 10: 2, 11: 72, 12: 72, 13: 72, 15: 72, 16: 72, 17: 24, 18: 72, 22: 72, 24: 72 };
      MailService.checkMailArrivedByClient(clients)
          .then(response => {
            response.data.forEach(clientStatus => {
              if (clientStatus.status === false) {
                this.expiredClients.push(clientStatus.clientId);
              }
              if(clientStatus.isSuccess === false){
                if(!this.expiredClients.includes(clientStatus.clientId)){
                  this.expiredClients.push(clientStatus.clientId);
                }
                this.clientsWithException.push(clientStatus.clientId);
              }
              if(clientStatus.notfound === true){
                this.clientsWithException.push(clientStatus.clientId);
              }
            });
          })
          .catch(error => {
            console.error("Error for bulk request:", error);
          });
    }
  },
  computed: {
    index() {
      return index
    },
    AllowClientIncomingStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowClientIncomingStatistics
      })
    },
    AllowPerformStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPerformStatistics
      })
    },
    AllowTaskPerformanceStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowTaskPerformanceStatistics
      })
    },
    AllowPagesCountStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPagesCountStatistics
      })
    },
    AllowPagesEconomistStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPagesEconomistStatistics
      })
    },
    AllowTestStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowTestStatistics
      })
    },
    AllowDeliveredStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeliveredStatistics
      })
    },
    isAllowMailsListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePrintPackage
      })
    },
    isAllowMailsMonitoringListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowMailsMonitoring
      })
    },
    isAllowMailsForwarding() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowMailForward
      })
    },
    isAllowDistributionByPostOfficesListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDistributionByPostOffices
      })
    },
    isAllowPrintPackagesListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePrintPackage
      })
    },
    isAllowPostPackagesListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePostPackage
      })
    },
    isAllowPostPackageGroupsListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePackageGroup
      })
    },
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    },
    isAllowUserStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowOperatorsStatistics
      })
    },
    isAllowUserManagements() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowAccountsManagement
      })
    },
    isAllowBulkUnsetPostPackageMails() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeleteFromPostPackage
      })
    },
    isCirclePdfAllowed() {
      return !!_.find(this.$store.getters.appLogin.regions, region => {
        return region.id === 1;
      })
    },

    isAllowPostIndexSettings() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPostIndexSettings
      })
    },
    isAllowPostIndexSearch() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowPostIndexSearch
      })
    },
  },
  mounted() {
    this.checkMailArrived();
  }
}
</script>

<style scoped>
.scrollable-area {
  max-height: 500px; /* Set your desired max height */
  overflow: hidden;
}

.content {
  padding: 0;
}

.scroll-box {
  max-height: inherit;
  overflow-y: auto;
  padding-right: 5px; /* Add a bit of padding to avoid horizontal scrollbar */
}

.v-alert {
  margin-bottom: 10px;
}
</style>
